module.exports = __webpack_public_path__ + "static/media/Badge_MedecineEsthetique.f1becc19.png";